import React from "react";
import { Card, CardContent } from "./card";

export const FrameMinimaps = () => {
  return (
    <div
      className="fixed"
      style={{
        width: "82px",
        height: "82px",
        bottom: "30px",
        right: "7px",
      }}
    >
      <Card
        className="w-[100px] h-[100px] overflow-hidden p-0 rounded-lg bg-white shadow-md"
        style={{
          boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.25)",
        }}
      >
        <CardContent className="p-1">
          <img
            className="w-full h-full object-cover rounded-md"
            alt=""
            src="/logo/asset-1xxxhdpi-1.png"
          />
        </CardContent>
      </Card>
    </div>
  );
};
